<article>
  <ng-container *ngIf="haveExpandedSources; else defaultImage">
    <picture class="picture-wrapper">
      <source
        media="(min-width: 1440px)"
        type="image/webp"
        [srcset]="item.pictureXlarge + '.webp' | src : src"
      />
      <source
        media="(min-width: 1024px)"
        type="image/webp"
        [srcset]="item.pictureLarge + '.webp' | src : src"
      />
      <source
        media="(min-width: 768px)"
        type="image/webp"
        [srcset]="item.pictureMedium + '.webp' | src : src"
      />
      <source
        *ngIf="item?.pictureSmall"
        media="(min-width: 576px)"
        type="image/webp"
        [srcset]="item.pictureSmall + '.webp' | src : src"
      />
      <ng-container *ngTemplateOutlet="defaultImage" />
    </picture>
  </ng-container>
</article>

<ng-template #defaultImage>
  <img
    alt="Large picture"
    loading="lazy"
    class="picture"
    [src]="item?.picture + '.webp' | src : src"
  />
</ng-template>
